import { render, staticRenderFns } from "./departCascader.vue?vue&type=template&id=2e35e6fc&"
import script from "./departCascader.vue?vue&type=script&lang=js&"
export * from "./departCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports